import React, { useMemo, useState } from 'react';
import {
  Chip,
  Autocomplete,
  TextField,
  IconButton,
  Button,
} from '@mui/material';
import Box from '@mui/material/Box';
import api from '../../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import LargePopper from '../assets/LargePopper';
import { guideReservation } from '../../../schema/guideReservation';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { SlidingPaneEdit } from '../../Page/SlidingPaneEdit';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNew';
import AddIcon from "@mui/icons-material/Add";

export default function MultiSelectGuideMUI({
  params,
  column,
  editingChip,
}: {
  params: any;
  column: any;
  editingChip?: (value: boolean) => void;
}) {
  const columnId = params.field;

  const [selectOptions, setSelectOptions] = useState<[]>([]);
  const [addingEntity, setAddingEntity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentEntity, setCurrentEntity] = useState<any>();
  const [transformedValue, setTransformedValue] = useState<any>(params.value);
  const allValue = useMemo(() => {
    return params.row;
  }, [params]);

  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});

  const fetchSelectOptions = async (
    searchText: string,
    columnName?: string,
    row?: any
  ) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });

    if (column?.url) {
      api.get(`/${column?.url}/names`, searchParams).then((result: any) => {
        if (result?.data) {
          result.data.unshift({ id: 0, name: '', isButton: true });
          setSelectOptions(result.data);
        } else {
          result.unshift({ id: 0, name: '', isButton: true });
          setSelectOptions(result);
        }
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const onChange = (event: any, value: any) => {
    let isReturn = false;
    const newValue = value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });

    params.api.setEditCellValue({
      id: params.id,
      field: params.field,
      value: newValue,
    });

    if (isReturn) {
      setAddingEntity(true);
    }
  };

  const handleOnChange = async (value: any) => {
    let isReturn = false;
    value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });

    if (isReturn) {
      setAddingEntity(true);
    } else {
      let selectedGuide: any = undefined;
      value.map((item: any) => {
        if (!item?.guide_id) {
          selectedGuide = item;
        }
      });
      const currentValue = [...value];

      if (selectedGuide) {
        const createdReservation = await api.post('/guide-reservations', {
          guide_id: selectedGuide?.id,
          guide_wage: allValue?.activity?.guide_wage,
          guide_wage_currency_id: allValue?.activity?.guide_wage_currency_id,
        });

        const newValue: any = currentValue.filter((item: any) => {
          return item?.guide_id;
        });

        newValue.push(createdReservation);

        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: newValue,
        });

        setTransformedValue(newValue);
      } else {
        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: value,
        });
        setTransformedValue(value);
      }
    }
  };

  return (
    <>
      <div className="multiselect-field w-full">
        <Autocomplete
          onKeyDown={(event) => {
            /*if (event.key === 'Enter') {
              event.defaultMuiPrevented = true;
            }*/
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              padding: '0',
            },
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
              paddingTop: '0px',
              paddingBottom: '0px',
            },
            '& .MuiButtonBase-root-MuiChip-root': {
              borderRadius: '4px',
            },
          }}
          PopperComponent={LargePopper}
          onInputChange={async (event, newInputValue) => {
            const options = await fetchSelectOptions(
              newInputValue,
              columnId,
              params?.row
            );
          }}
          multiple
          fullWidth={true}
          options={selectOptions}
          getOptionLabel={(option) => option?.name}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          value={transformedValue}
          size="small"
          onChange={(event, newValue) => {
            handleOnChange(newValue);
          }}
          autoHighlight={false}
          renderOption={(props: any, option: any) => {
            return (
              <Box
                component="li"
                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option?.isButton && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    size={'small'}
                    fullWidth
                  >
                    Add new
                  </Button>
                )}
                {option?.name ? option?.name : '-'}
              </Box>
            );
          }}
          renderInput={(paramsForInput) => {
            return (
              <TextField
                {...paramsForInput}
                size="small"
                InputLabelProps={{
                  style: {
                    fontSize: 13,
                    paddingTop: 2,
                  },
                }}
                onFocus={async (event) => {
                  const options = await fetchSelectOptions(
                    '',
                    columnId,
                    params?.row
                  );
                }}
                //autoFocus={true}
                InputProps={{
                  ...paramsForInput.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress
                          color="inherit"
                          size={20}
                          className={
                            'absolute right-[9px] text-[#b7b7b7] top-[1px]'
                          }
                        />
                      ) : null}
                      {paramsForInput.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          renderTags={(value, getTagProps, label: any) => {
            return value.map((option, index) => {
              let optionName = option?.guide?.name ? option?.guide?.name : '';
              if (option?.guide_wage) {
                optionName += ` (${option?.guide_wage}${
                  option?.guide_wage_currency
                    ? ` ${option?.guide_wage_currency?.name}`
                    : ''
                })`;
              }

              return (
                <Chip
                  {...getTagProps({ index })}
                  label={optionName}
                  key={`chip-item-${index}`}
                  id={`chip-item-${index}`}
                  sx={{
                    '& .MuiChip-label': {
                      paddingRight: '6px',
                    },
                    height: 'auto',
                    minHeight: '32px',
                    lineHeight: '20px',
                  }}
                  deleteIcon={
                    <>
                      <IconButton
                        key={`chip-edit-button-${option?.id}-${index}`}
                        id={`chip-edit-button-${option?.id}-${index}`}
                        aria-label="edit"
                        size="small"
                        color={'primary'}
                        onClick={(event: any) => {
                          if (event?.target?.nodeName === 'BUTTON') {
                            return false;
                          }
                          console.log('You clicked the edit button');

                          setOpenedSlidingPane({
                            schema: guideReservation(),
                            row: option,
                          });
                          return true;
                        }}
                        sx={{
                          padding: '0px',
                          '& .MuiSvgIcon-root': {
                            width: '15px',
                            height: '15px',
                          },
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        key={`chip-delete-button-${option?.id}-${index}`}
                        id={`chip-delete-button-${option?.id}-${index}`}
                        aria-label="delete"
                        size="small"
                        color={'error'}
                        sx={{
                          padding: '0px',
                          paddingRight: '8px',
                          '& .MuiSvgIcon-root': {
                            width: '15px',
                            height: '15px',
                          },
                        }}
                        onClick={(event) => {
                          console.log('You clicked the delete button');
                          const newValue = value.filter(
                            (item: any) => item.id !== option.id
                          );
                          handleOnChange(newValue);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </>
                  }
                />
              );
            });
          }}
        />
      </div>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={(value) => {
            if (value) {
              const oldValue: any = [...params.value];

              oldValue.map((item: any, index: number) => {
                if (item?.id === value?.id) {
                  oldValue[index] = value;
                }
              });

              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: oldValue,
              });

              setTransformedValue(oldValue);
            }
            /*  const tempValue = currentState.value ? [...currentState.value] : [];

            const newValue = tempValue.map((item: any) => {
              return item?.id === value?.id ? value : item;
            });
            setOpenedSlidingPane({});
            setCurrentState({
              value: newValue,
              send: false,
            });

            if (refreshMainTableData) {
              refreshMainTableData();
            }*/

            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}

      {addingEntity && (
        <SlidingPaneAddNew
          schema={guideReservation()}
          mainSchema={guideReservation()}
          id={'new'}
          hasSlidingPane={false}
          onSubmit={(value: any) => {
            if (value) {
              const oldValue: any = [...params.value];

              oldValue.map((item: any, index: number) => {
                if (item?.id === value?.id) {
                  oldValue[index] = value;
                }
              });

              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: oldValue,
              });

              setTransformedValue(oldValue);

              if (editingChip) {
                editingChip(true);
              }
              setAddingEntity(false);
            }
          }}
          propertiesFromTable={params.row}
          row={{}}
          onClose={(value) => {
            setAddingEntity(false);
          }}
        />
      )}

      {/*{addingEntity && (
        <EntityDialog
          schema={column?.tempSchema}
          onClose={() => {
            return setAddingEntity(false);
          }}
          row={params.row}
          isOpen={addingEntity}
          properties={currentEntity}
          onSubmit={(value) => {
            const oldValue: any = [...params.value];

            oldValue.map((item: any, index: number) => {
              if (item?.id === value?.id) {
                oldValue[index] = value;
              }
            });

            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: oldValue,
            });

            if (editingChip) {
              editingChip(true);
            }
          }}
        />
      )}*/}
    </>
  );
}
